import React from "react";
import { Outlet } from "react-router-dom";

function Frame(props) {
  return <Outlet />;
}

export default Frame;
